// tslint:disable: max-line-length
import axios from 'axios';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from './../indexed';
import { getStandardTypeFilterValue } from './../enums/labels/getStandardTypeFilterValue';
import axiosInstance from './../helpers/interceptor';
import { userHotelDetails } from './../helpers/handleBrandAndHotelData';
import moment from 'moment';
import { notificationsPath } from '../utils/endpoints';
import { IActionPlanListRequest } from '../app/@types/actionPlanList';

export const getStandards = async () => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/actionPlan/focusAreaOptionsDefault/${selectedBrand}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/actionPlan/focusAreaOptionsDefault/${selectedBrand}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/actionPlan/focusAreaOptionsDefault/${selectedBrand}`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const getAssessments = async () => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customerAssessment/publishedDates/?page=1&sort=-insertDate&pageSize=6&hotelIds=${selectedHotel}&`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customerAssessment/publishedDates/?page=1&sort=-insertDate&pageSize=6&hotelIds=${selectedHotel}&`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customerAssessment/publishedDates/?page=1&sort=-insertDate&pageSize=6&hotelIds=${selectedHotel}&`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const getFocusAreaOptions = async (
  selectedAssessmentId,
  selectedTemplateId,
  selectedStandardType
) => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/actionPlan/focusAreaOptions?&hotelId=${selectedHotel}&assessmentId=${selectedAssessmentId}&templateId=${selectedTemplateId}&standard=${selectedStandardType === 'LQA' ? 'LQA' : getStandardTypeFilterValue(selectedStandardType)}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/actionPlan/focusAreaOptions?&hotelId=${selectedHotel}&assessmentId=${selectedAssessmentId}&templateId=${selectedTemplateId}&standard=${selectedStandardType === 'LQA' ? 'LQA' : selectedStandardType}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/actionPlan/focusAreaOptions?&hotelId=${selectedHotel}&assessmentId=${selectedAssessmentId}&templateId=${selectedTemplateId}&standard=${selectedStandardType === 'LQA' ? 'LQA' : getStandardTypeFilterValue(selectedStandardType)}`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const getFocusAreaOptionsDefault = async (actionPlanId?: number) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/actionPlan/focusAreaOptionsDefault/${selectedBrand}?${actionPlanId ? '&actionPlanId=' + actionPlanId : ''}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/actionPlan/focusAreaOptionsDefault/${selectedBrand}?${actionPlanId ? '&actionPlanId=' + actionPlanId : ''}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/actionPlan/focusAreaOptionsDefault/${selectedBrand}?${actionPlanId ? '&actionPlanId=' + actionPlanId : ''}`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const createActionPlan = async (payLoad) => {
  const { userData } = userHotelDetails();
  const { data } = await axios.post(
    `${Env.API_URL}/actionPlan/`,
    { ...payLoad, isClientApp: true },
    {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    }
  );
  return data;
};

export const getSelfAssessmentDetails = async (assessmentId) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/customerAssessment/apdetail/${assessmentId}`
  );
  return data;
};

export const fetchNotifications = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const apiUrl = `${notificationsPath}?${queryString}`;
  return await axiosInstance.get(apiUrl);
};

export const actionPlanList = async (payLoad: IActionPlanListRequest) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  payLoad.hotelId = selectedHotel;
  payLoad.brandId = selectedBrand;
  const apiUrl = `${Env.API_URL}/actionPlan/list`;
  const { data } = await axiosInstance.get(apiUrl, {
    params: payLoad,
  });
  return data;
};

export const actionPlanSeriesListForUser = async (
  assigneesList,
  radioCheck,
  status,
  dueDateStart,
  dueDateFinal,
  selectedFocusArea,
  pageNumber,
  isOverDue,
  both,
  andOr
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  const startDate = dueDateStart
    ? moment(dueDateStart).startOf('day').toString()
    : undefined;
  const endDate = dueDateFinal
    ? moment(dueDateFinal).endOf('day').toString()
    : undefined;
  const payload: any = {
    hotelId: selectedHotel,
    pageSize: pageNumber,
    page: '1',
    sort: '-id',
    isClientApp: true,
    isSeries: true,
    brandId: selectedBrand,
  };
  if (isOverDue) {
    payload.overdue = true;
  }
  if (andOr !== undefined) {
    payload.cond = !andOr;
  }
  if (!both) {
    radioCheck === 'sent'
      ? (payload.ownerId = assigneesList)
      : (payload.assigneeId = assigneesList);
  } else {
    payload.ownerId = assigneesList;
    payload.assigneeId = assigneesList;
  }
  if (startDate) {
    payload.startDate = startDate;
  }
  if (endDate) {
    payload.endDate = endDate;
  }
  if (status) {
    payload.status = status;
  }
  if (selectedFocusArea) {
    payload.categoryIds = selectedFocusArea;
  }
  const apiUrl = `${Env.API_URL}/actionPlan/list`;
  const { data } = await axiosInstance.get(apiUrl, {
    params: payload,
  });
  return data;
};

export const actionPlansSeries = async (selectedAss, parentId?: number) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/actionPlan/${parentId}/getSeries`
  );
  return data;
};

export const actionplansCount = async () => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/actionPlan/latestCount?&brandId=${selectedBrand}&hotelId=${selectedHotel}&isClientApp=true`
  );
  return data;
};
